<template>
    <v-container fluid dense align="start" justify="space-between" class="pt-0 pl-2 pr-2 pb-1">
        <v-row dense class="pt-1 pb-1">
            <v-col
                    cols="12"
                    md="2"
            >
                <v-text-field
                        v-model="filters.product_woo_commerce_product_sku"
                        clearable
                        label="Sku"
                ></v-text-field>
            </v-col>
            <v-col
                    cols="12"
                    md="2"
            >
                <v-text-field
                        v-model="filters.order_item_woo_commerce_order_id"
                        clearable
                        label="Woo Commande"
                ></v-text-field>
            </v-col>
            <v-col
                    cols="12"
                    md="2"
            >
                <v-menu
                        v-model="order_item_created_datetime_gte_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="filters.order_item_created_datetime_gte"
                                label="Du"
                                prepend-icon="event"
                                clearable
                                readonly
                                v-bind="attrs"
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="filters.order_item_created_datetime_gte" @input="order_item_created_datetime_gte_menu = false"></v-date-picker>
                </v-menu>
            </v-col>
            <v-col
                    cols="12"
                    md="2"
            >
                <v-menu
                        v-model="order_item_created_datetime_lte_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="filters.order_item_created_datetime_lte"
                                label="au"
                                prepend-icon="event"
                                clearable
                                readonly
                                v-bind="attrs"
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="filters.order_item_created_datetime_lte" @input="order_item_created_datetime_lte_menu = false"></v-date-picker>
                </v-menu>
            </v-col>

            <v-col
                    cols="12"
                    md="2"
            >
                <v-select
                        v-model="filters.order_item_shipping_class"
                        :items="order_item_shipping_class"
                        item-text="label"
                        item-value="value"
                        clearable
                        label="Envoi"
                ></v-select>
            </v-col>

            <v-col
                    cols="12"
                    md="2"
            >
                <v-select
                        v-model="filters.order_item_status"
                        :items="order_item_status"
                        item-text="label"
                        item-value="value"
                        clearable
                        label="Statut de la commande"
                ></v-select>
            </v-col>

        </v-row>
        <v-row dense  class="pt-1 pb-1" align="start">
            <v-col
                    cols="12"
                    md="2"
            >
                <v-select
                        v-model="filters.order_item_warehouse_status"
                        :items="order_item_warehouse_status"
                        item-text="label"
                        item-value="value"
                        clearable
                        label="Statut Atelier"
                ></v-select>
            </v-col>
            <v-col
                    cols="12"
                    md="2"
            >
                <v-text-field
                        v-model="filters.store_name"
                        clearable
                        label="Boutique"
                ></v-text-field>
            </v-col>

            <v-spacer></v-spacer>
            <v-btn
                    color="red"
                    title="Synchroniser une commande manquante"
                    @click="openDialogSynchroniseOrderItem()"
                >
                <v-icon>mdi-sync</v-icon>
            </v-btn>
        </v-row>
        <v-dialog
                v-model="dialog"
                :loading="loading"
                max-width="490"
        >
            <v-card>
                <v-card-title class="headline">Récupérer une commande manquante ?</v-card-title>

                <v-card-text>
                    En cas de commande manquante, vous pouvez saisir un id de commande WooCommerce.<br/><br/>
                    Cela prendra quelques minutes.<br/><br/>
                    <v-text-field
                            v-model="sync_woo_commerce_order_id"
                            label="WooCommerce Id"
                            clearable
                    >
                    </v-text-field>
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="red darken-1"
                            outlined
                            @click="dialog = false"
                    >
                        Annuler
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="green darken-1"
                            @click="synchroniseOrderItem()"
                    >
                        Récupérer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import {debounce} from "../../../helpers/debounce";

    export default {
        name: 'DetailedOrdersFilters.vue',
        data() {
            return {
                dialog: false,
                loading: false,
                sync_woo_commerce_order_id: '',
                order_item_created_datetime_gte_menu: false,
                order_item_created_datetime_lte_menu: false,
                filters: {
                    store_name: '',
                    order_item_woo_commerce_order_id: '',
                    order_item_shipping_class: '',
                    product_woo_commerce_product_sku:'',
                    order_item_created_datetime_gte: '',
                    order_item_created_datetime_lte:'',
                    shipment_tracking_number: '',
                    shipment_recipient_address_recipient_name: '',
                },
                order_item_warehouse_status: [
                    {label: 'Incomplète', value: 'INCOMPLETE'},
                    {label: 'A l\'atelier', value: 'AT_WAREHOUSE'},
                    {label: 'Complète', value: 'COMPLETE'},
                    {label: 'Collecte en attente', value: 'PENDING_COLLECT'},
                    {label: 'Collectée', value: 'COLLECTED'},
                    {label: 'Emballée', value: 'PACKED'},
                    {label: 'Prête à envoyer', value: 'READY_TO_SHIP'},
                    {label: 'Envoyée', value: 'SHIPPED'},
                    {label: 'Anomalie', value: 'ANOMALY'},
                ],
                order_item_shipping_class: [
                    {label:'Direct', value:'DIRECT'},
                    {label:'Premium', value:'PREMIUM'},
                ],
                order_item_status: [
                    {label: this.$i18n.t('orders.status.pending_delivery'), value:'PENDING_DELIVERY'},
                    {label: this.$i18n.t('orders.status.pending_customer_acceptance'), value:'PENDING_CUSTOMER_ACCEPTANCE'},
                    {label: this.$i18n.t('orders.status.available_for_transfer'), value:'AVAILABLE_FOR_TRANSFER'},
                    {label: this.$i18n.t('orders.status.transferred'), value:'TRANSFERRED'},
                    {label: this.$i18n.t('orders.status.pending_payout'), value:'PENDING_PAYOUT'},
                    {label: this.$i18n.t('orders.status.paid'), value:'PAID'},
                    {label: this.$i18n.t('orders.status.pending_refund'), value:'PENDING_REFUND'},
                    {label: this.$i18n.t('orders.status.refunded'), value:'REFUNDED'},
                    {label: this.$i18n.t('orders.status.archived'), value:'ARCHIVED'},
                    {label: this.$i18n.t('orders.status.anomaly'), value:'ANOMALY'},
                    {label: this.$i18n.t('orders.status.merged'), value:'MERGED'},
                    {label: this.$i18n.t('orders.status.pending_cancellation'), value:'PENDING_CANCELLATION'},
                    {label: this.$i18n.t('orders.status.cancelled'), value:'CANCELLED'},
                ],
            }
        },
        methods: {
            getStatusLabel(status) {
                return this.$i18n.t('orders.status.' + status.toLowerCase())
            },
            synchroniseOrderItem() {
                this.loading = true;
                this.$axios.post('order_items/synchronizations', {'woo_commerce_order_ids' : [this.sync_woo_commerce_order_id]})
                    .then(() => {
                        this.dialog = false;
                        this.loading = false;
                    })
                    .catch(() => {
                        this.dialog = false;
                        this.loading = false;
                    });
            },
            openDialogSynchroniseOrderItem() {
                this.sync_woo_commerce_order_id = '';
                this.dialog = true;
            }

        },
        computed: {

        },
        watch: {
            filters: {
                handler: debounce(function (value) {
                    this.$emit('onFiltersChanged', value);
                }, 500),
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
